import { apiGet, apiPost, unwrapPaginated } from './helpers'

const PATH = 'inv/movements'

export default {
  listPaginated: (perPage = 10, params = {}, page = 1) =>
    apiGet(`${PATH}/${perPage}`, { ...params, page }).then(unwrapPaginated),
  create: data => apiPost(PATH, data),
}
